import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PhoneInput from 'react-phone-input-2';
import axios from 'axios';
import { Box, Button, Grid, Modal, Tab, Tabs, TextField, Typography } from '@mui/material'
import { Backdrop } from "@mui/material";
import toast, { Toaster } from 'react-hot-toast';
import { jwtDecode } from 'jwt-decode';
import '../SignInComponent/SignIn.css'
import CustomSpinner from '../CustomeSpinner/CustomeSpinner';
import loginimg from '../../assets/images/MANALI.jpg';
import environment from '../../environment/environment';

const loginmodalstyle = {
    position: "relative",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "70%",
    maxWidth: "1000px",
    maxHeight: "fit-content",
    bgcolor: "white !important",
    border: "1px solid #fff",
    borderRadius: "10px",
    boxShadow: 30,
    p: 4,
    overflowY: "auto",
    "@media (max-width: 600px)": {
        width: "90%",
        maxHeight: "100vh",
        height: '500px',
    },
};
const SignIn = ({ isModelSign, closePopup, userDetais, isBookOnline, packageItemInfo, packageItemList,packageData }) => {
    const [open, setOpen] = useState(false);
    const [fullName, setFullName] = useState('');
    const [mobileNo, setMobileNo] = useState('');
    const [confirmPass, setConfirmPass] = useState('');
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('User');
    const [fullNameError, setFullNameError] = useState('');
    const [mobileNoError, setMobileNoError] = useState('');
    const [confirmPassError, setConfirmPassError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [userName, setUserName] = useState('');
    const [userNameError, setUserNameError] = useState('');
    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [value, setValue] = useState('Login');
    const [userDetails, setUserDetails] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        setOpen(isModelSign);
    })
    const handleChange = (event, newValue) => {
        setValue(newValue)
        handleClearForm()
    };

    const handleClose = () => {
        // handleClearForm()
        closePopup(false);
        setOpen(false);
        // setValue('Login')
    };
    const handleChangeFullName = (event) => {
        const value = event.target.value
        if (!value) {
            setFullNameError('Please provide a valid information')
        } else {
            setFullNameError('')
        }
        setFullName(value)
    }

    const handleChangeEmail = (event) => {
        const value = event.target.value
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(value)) {
            setEmailError('Please provide a valid information')
        } else if (!value) {
            setEmailError('Please provide a valid information')
        } else {
            setEmailError('')
        }
        const username = value.split("@")[0];
        setUserName(username);
        setEmail(value)
    }

    const handleChangeMobileNo = (value) => {
        // const value = event;
        if (!value) {
            setMobileNoError('Invalid mobile number format');
        } else {
            setMobileNoError('');
        }
        setMobileNo(value);
    };

    const handleChangeUserName = (event) => {
        const value = event.target.value
        if (!value) {
            setUserNameError('Please provide a valid information')
        } else {
            setUserNameError('')
        }
        setUserName(value)
    }

    const handleChangePassword = (e) => {
          // const passwordRegex = /^(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{8,14}$/
        const newPassword = e.target.value.slice(0, 14); 
        if (newPassword.length < 8) {
          setPasswordError("Password must be 8-14 characters long");
        } else {
          setPasswordError("");
        }
        setPassword(newPassword);
      };

    const handleChangeConfirmPass = (event) => {
        const value = event.target.value
        if (!value) {
            setConfirmPassError('Please provide a valid information')
        } else if (value !== password) {
            setConfirmPassError('Password does not match')
        } else {
            setConfirmPassError('')
        }
        setConfirmPass(value)
    }
    const handleSubmitSignIn = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        let isValid = true;

        if (!userName) {
            setUserNameError('Please provide a valid username');
            isValid = false;
        }
        if (!password) {
            setPasswordError('Please provide a valid password');
            isValid = false;
        }
        if (!isValid) return;

        const requestBody = {
            userName: userName,
            password: password,
        };

        try {
            const response = await fetch(`${environment.config.apiBaseUrl}auth/signIn`, 
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody),
            });

            if (response.status === 200) {
                const result = await response.json();
                const decoded = jwtDecode(result.token)
                localStorage.setItem('token', JSON.stringify(decoded));
                localStorage.setItem('accessToken', result.token);
                userDetais(decoded);
                setUserDetails(decoded);
                setIsLoggedIn(true);
                handleClearForm();
                handleClose();
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
                if (isBookOnline) {
                    navigate('/booking', { state: { packageData: packageItemInfo || packageItemList } });
                }
                toast.success('Logged in Successfully!')
            } else {
                toast.error(response.message || 'Login failed');
                setTimeout(() => {
                    setIsLoading(false);
                }, 1500);
            }
        } catch (error) {
            toast.error('An error occurred. Please try again.');
            setTimeout(() => {
                setIsLoading(false);
            }, 1500);
        }
    };

    const handleSubmitSignUp = async (event) => {
        event.preventDefault();

        let isValid = true;
        setFullNameError('');
        setEmailError('');
        setMobileNoError('');
        setPasswordError('');
        setConfirmPassError('');
    
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    
        if (!fullName) {
            setFullNameError('Please provide a valid full name');
            isValid = false;
        }
    
        if (!email || !emailRegex.test(email)) {
            setEmailError('Please provide a valid email');
            isValid = false;
        }
    
        if (!mobileNo) {
            setMobileNoError('Please provide a valid mobile number');
            isValid = false;
        }
    
        if (!password) {
            setPasswordError('Please provide a valid password');
            isValid = false;
        }
    
        if (!confirmPass) {
            setConfirmPassError('Please confirm your password');
            isValid = false;
        } else if (password !== confirmPass) {
            setConfirmPassError('Password does not match');
            isValid = false;
        }
    
        if (!isValid) {
            return;
        }
    
        setIsLoading(true);
    
        const requestBody = {
            fullName,
            email,
            userName,
            mobileNo,
            password,
            confirmPassword: confirmPass,
            roles: 'User',
        };
    
        try {
            const response = await axios.post(`${environment.config.apiBaseUrl}auth/signUp`, requestBody, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.status === 200) {
                toast.success("Your user name and password have been sent to your registered email.");
                handleClearForm();
                handleClose();
            } else {
                toast.error("Error creating user: " + (response.data?.message || 'Unknown error'));
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || 'Network error occurred');
        } finally {
            setIsLoading(false);
        }
    };
    
    const handleClearForm = () => {
        setUserName('')
        setUserNameError('')
        setPassword('')
        setPasswordError('')
        setFullName('')
        setFullNameError('')
        setMobileNo('')
        setMobileNoError('')
        setEmail('')
        setEmailError('')
        setConfirmPass('')
        setConfirmPassError('')
    }
    return (
        <div>
            <Modal className='login-modal' open={open} onClose={handleClose} aria-labelledby="modal-modal-title">
                <Box sx={loginmodalstyle}>
                    {isLoading &&
                        <Backdrop
                            sx={{
                                color: "#fff",
                                zIndex: (theme) => theme.zIndex.drawer + 1,
                                backdropFilter: "blur(5px)",
                                backgroundColor: "rgba(0, 0, 0, 0.4)"
                            }}
                            open={isLoading}
                        >
                            <CustomSpinner color="inherit" />
                        </Backdrop>
                    }
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                        {/* <strong>Add Customer</strong> */}
                        <button
                            type="button"
                            className="signIn-close-btn"
                            onClick={handleClose}
                        >  &times;</button>
                    </Typography>
                    <Box>
                        <form className='login-form'>
                            <div className='col-md-6 login-img-fluid'>
                                <img className='login-img' src={loginimg} alt="Login"></img>
                            </div>
                            <div className='col-md-6 form-container'>
                                <Tabs
                                    className="loginpage-tabs"
                                    value={value}
                                    onChange={handleChange}
                                    variant="scrollable"
                                    aria-label="visible arrows tabs example"
                                    fullWidth
                                    sx={{
                                        width: {
                                            xs: '100%',
                                            sm: '200px',
                                            md: '400px',
                                        },
                                        '& .MuiTabs-list': {
                                            display: 'flex',
                                            justifyContent: 'between',
                                            width: {
                                                xs: '400px',
                                                sm: 'auto',
                                                md: '100%',
                                            },
                                        },
                                        '& .MuiTabs-scroller': {
                                            display: 'flex',
                                            justifyContent: 'center',
                                        },
                                    }}
                                >
                                    <Tab
                                        label={
                                            <Box sx={{ display: 'flex', flexDirection: 'column', width: { xs: '100%' }, textTransform: 'capitalize', fontSize: '18px', fontWeight: '500' }}>
                                                <div >
                                                    <p className="text-center p-0 m-0">Login</p>
                                                </div>
                                            </Box>
                                        }
                                        value='Login'
                                        sx={{
                                            width: {
                                                xs: '50%',
                                                md: '50%'
                                            },
                                            color: value === "Login" ? 'white' : 'inherit',
                                            borderRadius: 1,
                                        }}
                                    />
                                    <Tab
                                        label={
                                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, textTransform: 'capitalize', fontSize: '18px', fontWeight: '500' }}>
                                                <div>
                                                    <p className="text-center p-0 m-0">Sign Up</p>
                                                </div>
                                            </Box>
                                        }
                                        value='Sign Up'
                                        sx={{
                                            width: {
                                                xs: '50%',
                                                md: '50%'
                                            },
                                            color: value === "Sign Up" ? 'white' : 'inherit',
                                            borderRadius: 1,
                                        }}
                                    />
                                </Tabs>
                                {value === 'Login' ? (
                                    <Grid className='login-form' container spacing={3} sx={{ marginTop: '50px' }}>
                                        <Grid item xs={12} sm={12} md={12} sx={{ fontSize: '16px', fontWeight: '600', }}>
                                            Log into Your Account
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <TextField fullWidth label="User Name" variant="outlined" value={userName} onChange={handleChangeUserName} />
                                            {userNameError && <p style={{ color: "red", margin: "2px" }}>{userNameError}</p>}
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <TextField fullWidth label="Password" variant="outlined" type='password' value={password}  inputProps={{minLength:8,maxLength:14}} onChange={handleChangePassword} />
                                            {passwordError && <p style={{ color: "red", margin: "2px" }}>{passwordError}</p>}
                                        </Grid>
                                        {/* <Grid item xs={12} sm={12} md={12} sx={{ fontSize: '13px', fontWeight: '600', textAlign: 'end', cursor: 'pointer', color: 'blue' }}>
                                            Forgot Password?
                                        </Grid> */}
                                        <Grid item xs={12} md={12}>
                                            <Button fullWidth type="submit" variant="contained" color="primary" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '48px' }} onClick={handleSubmitSignIn}>
                                                Sign In
                                            </Button>
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Grid container spacing={1} className='register-form' sx={{ marginTop: '60px', overflowY: 'auto', height: '430px' }}>
                                        <Grid item xs={12} sm={12} md={12} sx={{ fontSize: '16px', fontWeight: '600', }}>
                                            Create Your Account
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <TextField fullWidth label="Full Name" variant="outlined" value={fullName} onChange={handleChangeFullName} />
                                            {fullNameError && <p style={{ color: "red", margin: "2px", fontSize: '10px' }}>{fullNameError}</p>}
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <TextField fullWidth label="Email Id" variant="outlined" value={email} onChange={handleChangeEmail} />
                                            {emailError && <p style={{ color: "red", margin: "2px", fontSize: '10px' }}>{emailError}</p>}
                                        </Grid>
                                        {/* <Grid item xs={12} sm={12} md={12}>
                                            <TextField fullWidth label="User Name" variant="outlined" value={userName} onChange={handleChangeUserName} disabled />
                                            {userNameError && <p style={{ color: "red", margin: "2px" }}>{userNameError}</p>}
                                        </Grid> */}
                                        {/* <Grid item xs={12} sm={12} md={12}>
                                            <TextField fullWidth label="Mobile No." variant="outlined" type='number' value={mobileNo} onChange={handleChangeMobileNo} />
                                            {mobileNoError && <p style={{ color: "red", margin: "2px", fontSize: '10px' }}>{mobileNoError}</p>}
                                        </Grid> */}
                                        <Grid item xs={12} sm={12} md={12}>
                                            <PhoneInput
                                                country={'in'}
                                                value={mobileNo}
                                                onChange={handleChangeMobileNo}
                                                inputStyle={{ width: '100%', height: '55px' }}
                                                countryCodeEditable={false}
                                            />
                                            {mobileNoError && <p style={{ color: "red", margin: "2px", fontSize: '10px' }}>{mobileNoError}</p>}
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField fullWidth label="Password" variant="outlined" type='password' value={password} inputProps={{minLength:8,maxLength:14}} onChange={handleChangePassword} />
                                            {passwordError && <p style={{ color: "red", margin: "2px", fontSize: '10px' }}>{passwordError}</p>}
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField fullWidth label="Confirm Password" variant="outlined" type='password' value={confirmPass} disabled={!password} onChange={handleChangeConfirmPass} />
                                            {confirmPassError && <p style={{ color: "red", margin: "2px", fontSize: '10px' }}>{confirmPassError}</p>}
                                        </Grid>
                                        <Grid item xs={12} md={12}>
                                            <Button className='mb-2' fullWidth type="submit" variant="contained" color="primary" style={{ backgroundColor: '#fff099', color: '#2d2b29', height: '48px' }} onClick={handleSubmitSignUp}>
                                                Sign Up
                                            </Button>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12} sx={{ fontSize: '13px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <div>Already Have An Account?</div>
                                            <button style={{ border: 'none', backgroundColor: 'unset', fontSize: "14px", fontWeight: '600' }} onClick={() => setValue('Login')}>Log In</button>
                                        </Grid>

                                    </Grid>
                                )}
                            </div>
                        </form>
                    </Box>
                </Box>

            </Modal>
        </div>
    )
}

export default SignIn
